import { RouteMatcher } from "@faire/web--source/common/routes/RouteMatcher";
import { route as cartRoute } from "@faire/web-api--source/routes/www/cart";
import { useLocation } from "react-router-dom";
var cartRouteMatcher = new RouteMatcher([
    cartRoute
]);
export var useIsOnCartPage = function() {
    var pathname = useLocation().pathname;
    return !!cartRouteMatcher.match(pathname);
};
